import { CnSwitch as UiCnSwitch } from '@/components/cn-switch';
import { connect, mapProps } from '@formily/react';
import { mapSize, mapStatus } from '../__builtins__';
export var CnSwitch = connect(UiCnSwitch, mapProps({
    value: 'checked',
}, mapSize, mapStatus));
